/*!
 * Dev dependencies.
 * @deps wp-i18n
 */

window.wp.hamazon = {};
